import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import api from "@/lib/api";
import { VideoCard, VideoEmbed, SocialEmbed, RawEmbed } from "@/components/VideoEmbed";
import { PLATFORM_LABELS, detectPlatform } from "@/lib/video";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 py-8 md:px-8" data-testid="videos-page">
      <div className="mb-8 max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent/20 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-accent-foreground">
          <Play size={13} /> Watch
        </span>
        <h1 className="mt-3 font-serif text-4xl font-bold tracking-tight md:text-5xl">CSRA on video</h1>
        <p className="mt-3 text-muted-foreground">
          TikToks, Reels and clips from around Aiken &amp; the CSRA — food, music, events and hidden gems.
        </p>
      </div>

      {loading ? (
        <p className="text-muted-foreground">Loading videos…</p>
      ) : videos.length === 0 ? (
        <p className="text-muted-foreground" data-testid="videos-empty">No videos yet — check back soon!</p>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {videos.map((v) => {
            const p = v.platform || detectPlatform(v.url);
            const social = p === "tiktok" || p === "instagram" || p === "facebook";
            const hug = !!v.embed_html || social;
            return (
              <div key={v.id}
                className={`overflow-hidden rounded-2xl border border-border bg-card ${hug ? "mx-auto w-fit max-w-full" : ""}`}
                data-testid={`video-card-${v.id}`}>
                {v.embed_html ? (
                  <div className="bg-white [&_iframe]:block [&_iframe]:max-w-full">
                    <RawEmbed html={v.embed_html} />
                  </div>
                ) : social ? (
                  <div className="bg-white p-1">
                    <SocialEmbed platform={p} url={v.url} testid={`video-embed-${v.id}`} />
                  </div>
                ) : (
                  <VideoCard video={v} />
                )}
                <div className="flex items-center justify-between gap-2 p-3">
                  <p className="truncate text-sm font-semibold">{v.title}</p>
                  <span className="shrink-0 rounded-full bg-muted px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">{PLATFORM_LABELS[p] || p}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
